import { isSameDay } from 'date-fns';

interface ResourceScheduleUnassignedItemAssignee {
  user_id: number | null;
  contact_id?: number | null;
  assignee_type?: 'user' | 'contractor';
}

interface ResourceScheduleUnassignedItem {
  scheduled_start?: string | null;
  scheduled_end?: string | null;
  assigned_to?: number | string | null;
  assigned_team?: string | null;
  assignees?: ResourceScheduleUnassignedItemAssignee[] | null;
}

export function filterResourceScheduleUnassignedItems<TItem extends ResourceScheduleUnassignedItem>(
  items: readonly TItem[],
  selectedDate: Date,
  timelineStart: Date,
): TItem[] {
  return items.filter((item) => {
    if (!item.scheduled_start || !item.scheduled_end) {
      return false;
    }

    const scheduledStart = new Date(item.scheduled_start);
    if (!isSameDay(scheduledStart, selectedDate)) {
      return false;
    }

    const scheduledEnd = new Date(item.scheduled_end);
    if (scheduledEnd <= timelineStart) {
      return false;
    }

    const hasAssignee = item.assigned_team
      || (Array.isArray(item.assignees) && item.assignees.length > 0)
      || item.assigned_to;

    return !hasAssignee;
  });
}